import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import CommentList from './commentList';
// import ShareList from './shareList';
// import OriginalList from './originalList';
import styles from './index.css';

class Main extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        type: PropTypes.number,
        pageInfo: PropTypes.object,
    };

    render() {
        const { content, type, pageInfo } = this.props;

        return (
            <div className={styles.main}>
                {type === 1 ? <CommentList content={content} pageInfo={pageInfo} /> : ''}
                {type === 103 ? <CommentList content={content} pageInfo={pageInfo} /> : ''}
                {type === 106 ? <CommentList content={content} pageInfo={pageInfo} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(Main);
